import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { CategorySelector } from '../components/CategorySelector';
import { Button } from '../components/ui/button';
import { TreatmentCategory } from '../types';

export function SelectCategory() {
  const navigate = useNavigate();
  const { clientId } = useParams();

  const handleCategorySelect = (category: TreatmentCategory) => {
    navigate(`/client/${clientId}/new-treatment/${category}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate(`/client/${clientId}`)}
              className="text-gray-600 hover:text-[#E91E8C]"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <h1 className="text-xl text-[#2d2d2d]">Seleccionar Categoría</h1>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-6">
        <div className="mb-6">
          <p className="text-gray-600">
            Selecciona el tipo de tratamiento que vas a realizar
          </p>
        </div>

        <CategorySelector onSelect={handleCategorySelect} />
      </main>
    </div>
  );
}
